import { FIELDS } from '@/shared/components/Offers/constants';

const inventoryFields = [
  {
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    locked: true,
    width: 65,
  },
  {
    field: FIELDS.PART_NUMBER,
    title: 'Part number',
    width: 200,
  },
  {
    field: FIELDS.DESCRIPTION,
    title: 'Desc',
    width: 200,
  },
  {
    field: FIELDS.MFR,
    title: 'Mfr',
    width: 200,
  },
  {
    field: FIELDS.QUANTITY,
    title: 'Qty',
    width: 200,
  },
  {
    field: FIELDS.CUSTOMER_PN,
    title: 'Cust PN',
    width: 200,
  },
  {
    field: FIELDS.CONDITION,
    title: 'Cond',
    width: 200,
  },
  {
    field: FIELDS.INVENTORY_CLASS_NAME,
    title: 'Class',
    width: 200,
  },
  {
    field: FIELDS.DATE_CODE,
    title: 'Date code',
    width: 200,
  },
  {
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Entered by',
    width: 200,
  },
  {
    field: FIELDS.TESTED,
    title: 'Tested',
    width: 200,
  },
  {
    field: FIELDS.TESTED_BY,
    title: 'Tested by',
    width: 200,
  },
];

export default inventoryFields;
